import axios from "axios";
import Api from "./axiosVersion1";
import { getAPIBaseUrlVersion1 } from "../utils/constants";
import {
  appendQueryString,
  buildQueryString,
  formUrlEncodedConfig,
} from "./serviceUtils";

const apiUrlVersion1Axios = getAPIBaseUrlVersion1();

export const getUsers = async () => {
  return Api.get(`/users`);
};

export const impersonateUser = async (body) => {
  return Api.post(`/login_anonymous/user`, body, formUrlEncodedConfig);
};

export const getUser = async (id) => {
  return Api.get(`/user/${id}`);
};

export const getUserDetailByToken = async (token) => {
  return axios.get(`${apiUrlVersion1Axios}/user_anonymous`, {
    headers: {
      token: token,
      "Content-Type": "application/json",
    },
  });
};


export const updateUser = async ({ id, data }) => {
  return Api.put(`/user/${id}`, data);
};

export const inviteExternalUser = async (data) => {
  return Api.post(`/invitation`, data, formUrlEncodedConfig);
};

export const getWatchlist = async (id) => {
  return Api.get(
    appendQueryString(`/cards/user/watchlist`, buildQueryString({ workflow_id: id }))
  );
};

export const getWatchlistUsers = async () => {
  return Api.get("/cards/user/watchlist_users");
};

export const inviteInternalUser = async (data) => {
  return Api.post(`/ldap-users`, data, formUrlEncodedConfig);
};

export const getLdapUserList = async (id) => {
  return Api.get("/ldap_user_na_tb");
};

export const sendResetMail = async ({ email }) => {
  return await Api.post(
    `forget_password/send_link?admin=${true}`,
    { email },
    formUrlEncodedConfig
  );
};

export const getUserProfileForAdmin = async (id) => {
  return await Api.get(`/user_profile/${id}`);
};

export const updateUserDetails = async ({ userId, data }) => {
  return await Api.put(`/user/${userId}`, data, formUrlEncodedConfig);
};

export const getBoardUser = async (boardId, userId) => {
  return Api.get(`/board_permission/${boardId}/user_id/${userId}`);
};

export const getCustomFields = async (boardId) => {
  return Api.get(`/board/${boardId}/custom-fields`);
};

export const addCustomField = async (boardId, data) => {
  const formData = new URLSearchParams();
  // Add basic fields
  formData.append('display_name', data.display_name);
  formData.append('field_type', data.field_type);
  formData.append('sequence', JSON.stringify(data.sequence));

  // Add settings array as is
  if (data.settings && Array.isArray(data.settings)) {
    formData.append('settings', JSON.stringify(data.settings));
  }

  return Api.post(`/board/${boardId}/custom-fields`, formData, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
};

export const updateCustomFieldSequence = async (boardId, data) => {
  return Api.put(`board/${boardId}/custom-fields/sequence`, data, formUrlEncodedConfig);
};

export const deleteCustomField = async (boardId, customFieldId) => {
  return Api.delete(`board/${boardId}/custom-fields/${customFieldId}`);
};

export const deleteUser = async (user_id) => {
  return Api.delete(`/user/${user_id}`);
};
